export default __webpack_public_path__ + "static/jaime-2ef4fdac2adffd3792a80a30c34aad91.jpg";